export const featuredWorks = [
  {
    id: 'work-1',
    title: '暗夜追踪',
    category: '悬疑剧集',
    categorySlug: 'suspense',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20thriller%20film%20scene%20with%20detective%20silhouette%20in%20rainy%20city%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20lighting%2C%20high%20contrast%2C%20film%20noir%20style%2C%20professional%20movie%20poster%20quality%2C%20clean%20background%20with%20dark%20tones&width=800&height=600&seq=work-01&orientation=landscape',
    description: '一位退役刑警被迫重返黑暗，追踪一桩尘封多年的连环案件。',
    rating: 9.2,
    year: 2026,
    episodes: 12,
  },
  {
    id: 'work-2',
    title: '春风十里',
    category: '都市情感',
    categorySlug: 'romance',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20urban%20drama%20film%20scene%20with%20couple%20walking%20under%20cherry%20blossom%20trees%20in%20modern%20city%2C%20warm%20spring%20sunlight%2C%20soft%20romantic%20atmosphere%2C%20cinematic%20photography%2C%20gentle%20color%20palette%2C%20clean%20simple%20background&width=800&height=600&seq=work-02&orientation=landscape',
    description: '在繁华都市中，两个灵魂相遇相知，谱写一段温暖治愈的爱情故事。',
    rating: 8.8,
    year: 2026,
    episodes: 24,
  },
  {
    id: 'work-3',
    title: '天机阁',
    category: '古装奇幻',
    categorySlug: 'fantasy',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20temple%20floating%20in%20clouds%20with%20mystical%20golden%20light%2C%20traditional%20architecture%20with%20magical%20elements%2C%20misty%20mountain%20landscape%2C%20cinematic%20epic%20fantasy%20film%20style%2C%20warm%20golden%20and%20crimson%20tones%2C%20clean%20background&width=800&height=600&seq=work-03&orientation=landscape',
    description: '少年意外踏入隐藏千年的天机阁，揭开尘封已久的仙界秘密。',
    rating: 9.5,
    year: 2025,
    episodes: 36,
  },
  {
    id: 'work-4',
    title: '极限追捕',
    category: '动作警匪',
    categorySlug: 'action',
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20police%20chase%20film%20scene%20on%20city%20highway%20with%20dramatic%20lighting%2C%20fast%20paced%20thriller%20atmosphere%2C%20professional%20movie%20cinematography%2C%20warm%20amber%20and%20dark%20tones%2C%20clean%20simple%20background&width=800&height=600&seq=work-04&orientation=landscape',
    description: '精英特警小组与跨国犯罪集团的生死较量，每一秒都是惊心动魄。',
    rating: 8.9,
    year: 2026,
    episodes: 16,
  },
];

export const categories = [
  { id: 'all', name: '全部作品', icon: 'ri-grid-line' },
  { id: 'suspense', name: '悬疑剧集', icon: 'ri-search-eye-line' },
  { id: 'romance', name: '都市情感', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '古装奇幻', icon: 'ri-magic-line' },
  { id: 'action', name: '动作警匪', icon: 'ri-police-car-line' },
  { id: 'comedy', name: '喜剧剧场', icon: 'ri-emotion-laugh-line' },
  { id: 'documentary', name: '纪录纪实', icon: 'ri-camera-lens-line' },
];

export const membershipPlans = [
  {
    id: 'basic',
    name: '基础会员',
    price: '19',
    period: '月',
    description: '适合轻度观影用户',
    features: [
      '高清画质观影体验',
      '每月10部免费影片',
      '移动端专属观看',
      '基础客服支持',
    ],
    highlighted: false,
    color: 'secondary',
  },
  {
    id: 'premium',
    name: '高级会员',
    price: '39',
    period: '月',
    description: '适合重度影视爱好者',
    features: [
      '超清4K画质体验',
      '无限量影片观看',
      '全平台多端同步',
      '独家原创内容抢先看',
      '优先客服支持',
      '无广告纯净观影',
    ],
    highlighted: true,
    color: 'primary',
  },
  {
    id: 'annual',
    name: '年度会员',
    price: '399',
    period: '年',
    description: '最超值的观影方案',
    features: [
      '超清4K画质体验',
      '无限量影片观看',
      '全平台多端同步',
      '独家原创内容抢先看',
      'VIP专属客服通道',
      '无广告纯净观影',
      '年度限定周边礼盒',
      '线下首映礼参与资格',
    ],
    highlighted: false,
    color: 'accent',
  },
];

export const faqItems = [
  {
    id: 'faq-1',
    question: '麻豆传媒的内容是否为正版授权？',
    answer: '麻豆传媒所有影视内容均获得正版授权，我们与国内外多家知名制作公司建立了长期合作关系，确保每一部作品都经过合法授权。用户可放心观看，享受高品质正版内容体验。',
  },
  {
    id: 'faq-2',
    question: '会员订阅后可以随时取消吗？',
    answer: '可以的。会员订阅采用灵活机制，您可以随时在账户设置中取消自动续费。取消后，当前付费周期内的会员权益将继续有效直至到期，到期后将不再自动续费。',
  },
  {
    id: 'faq-3',
    question: '支持哪些设备观看？',
    answer: '麻豆传媒支持全平台观看，包括iOS、Android移动端、Web网页端、iPad平板端以及智能电视TV端。一个账号最多可同时登录3台设备，随时随地畅享精彩内容。',
  },
  {
    id: 'faq-4',
    question: '如何成为麻豆传媒的内容创作者？',
    answer: '我们欢迎优秀的影视内容创作者加入麻豆传媒平台。您可以通过"关于我们"页面的联系方式提交作品集和合作意向，我们的内容团队将在7个工作日内与您联系，共同探讨合作可能。',
  },
  {
    id: 'faq-5',
    question: '观影过程中遇到技术问题怎么办？',
    answer: '如果您在观影过程中遇到播放卡顿、画面异常等技术问题，可以联系我们的技术支持团队。工作日9:00-21:00提供在线客服支持，您也可以发送邮件至客服邮箱，我们会在24小时内回复处理。',
  },
];